import { API2_HOST } from '@/utils/constants';

import request from '../request';
import { IBaseResponse } from '../types/common';
import { IDeleteAccountParams, IDeleteAccountResponse } from './types';

export const deleteAccount = (
  params: IDeleteAccountParams,
): Promise<IDeleteAccountResponse> => {
  const url = `${API2_HOST}/user/private/account/deletion`;
  return new Promise((resolve, reject) => {
    request
      .post<IBaseResponse<IDeleteAccountResponse>>(url, {
        body: JSON.stringify(params),
      })
      .then((response: IBaseResponse<IDeleteAccountResponse>) => {
        resolve(response.result as IDeleteAccountResponse);
      })
      .catch((error: any) => {
        reject(error.response ? error.response.data : error);
      });
  });
};
